const config = {
  API_URL: process.env.REACT_APP_API_URL || '/api',
  SYNCFUSION_LICENSE: process.env.REACT_APP_SYNCFUSION_LICENSE || 'Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXxfcHRWR2NcVkB3W0E=',
  APP_NAME: 'Pension',
  APP_VERSION: '1.0.0',
  DATE_FORMAT: 'DD/MM/YYYY',
  ROWS_PER_PAGE: 10,
  TOAST_AUTO_CLOSE: 5000,
  DEFAULT_LANGUAGE: 'he',
  SUPPORTED_LANGUAGES: ['he', 'en'],
};

export default config;